import { fetchCurrentUser, updateCurrentUser } from "@/apis/profileApi";

export const profileService = {
  fetchCurrentUser,
  updateCurrentUser,
};
